import axios from 'axios';

/**
 * Extrae el mensaje de error del backend de un error desconocido
 * @param error - Error capturado
 * @returns Mensaje de error del backend o mensaje genérico
 */
export function getErrorMessage(error: unknown): string {
  // Ojo: AxiosError también es instanceof Error, por eso este chequeo va primero;
  // de lo contrario nunca se llega a extraer el mensaje real del backend y siempre
  // se devuelve el mensaje genérico de axios (p. ej. "Request failed with status code 401").
  if (axios.isAxiosError(error)) {
    const axiosError = error;
    if (axiosError.response?.data) {
      const data = axiosError.response.data as unknown;
      // Intenta extraer el mensaje del backend
      if (typeof data === 'string') return data;
      if (data && typeof data === 'object') {
        const errorData = data as Record<string, unknown>;
        if (typeof errorData.descripcion === 'string') return errorData.descripcion;
        if (typeof errorData.message === 'string') return errorData.message;
        if (typeof errorData.Message === 'string') return errorData.Message;
        if (typeof errorData.error === 'string') return errorData.error;
      }
    }
    return axiosError.message || 'Error desconocido';
  }

  // Si es un ServiceError (tiene message)
  if (error instanceof Error) {
    return error.message;
  }

  // Si es un string
  if (typeof error === 'string') {
    return error;
  }

  // Si es un objeto con message
  if (error && typeof error === 'object' && 'message' in error) {
    return String(error.message);
  }

  return 'Error desconocido';
}
